<template>
    <img
        class="captcha-img"
        :src="img"
        :style="{ width: width + 'px', height: height + 'px' }"
        title="看不清？点击图片更换"
        @click="refresh"
    />
</template>

<script>
import {
    GenerateCaptcha
} from "@/api/index.js"

export default {
    name: "CaptchaImg",
    props: {
        width: {
            type: Number,
            default: 130
        },
        height: {
            type: Number,
            default: 46
        }
    },
    data() {
        return {
            img: "",
            captcha_id: "",
            loading: false
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        // 拉取新图形验证码；每次弹窗打开及发送失败后都应调用
        refresh() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            GenerateCaptcha().then(({ data }) => {
                this.captcha_id = data.captcha_id;
                this.img = data.image;
                this.$emit("loaded", this.captcha_id);
            }).catch((res) => {
                this.$emit("error", res);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped lang="scss">
.captcha-img {
    display: block;
    border-radius: 6px;
    cursor: pointer;
    user-select: none;
}
</style>
